import { createSlice } from "@reduxjs/toolkit";
// import _ from 'lodash';

const globalReducer = createSlice({
    name: 'globalReducer',
    initialState: {
        loaderState: false,
        userPermissions: []
    },
    reducers: {
        setLoaderState: (state, action) => {
            state.loaderState = action.payload;
        },
        setUserPermissions: (state, action) => {
            state.userPermissions = action.payload;
        },
        clearUserPermissions: (state) => {
            state.userPermissions = [];
        }
    }
})

export const { setLoaderState, setUserPermissions, clearUserPermissions } = globalReducer.actions;

export default globalReducer.reducer;